import {Pipe, PipeTransform} from '@angular/core';
import {ETipoCuestionario} from '@core/models';

@Pipe({name: 'tipoInput'})
export class tipoInputPipe implements PipeTransform {
  transform(dato: number): any {
    if (!dato) {
      return dato;
    }

    switch (dato) {
      case ETipoCuestionario.TEXTO:
        return 'TEXTO';
      case ETipoCuestionario.EMAIL:
        return 'EMAIL';
      case ETipoCuestionario.RUT:
        return 'RUT';
      case ETipoCuestionario.NUMERO:
        return 'NUMÉRICO';
      case ETipoCuestionario.OPCIONES:
        return 'OPCIONES';
      case ETipoCuestionario.FECHA:
        return 'FECHA';
      case ETipoCuestionario.CHECK:
        return 'CHECK';
      case ETipoCuestionario.TEXTO_LARGO:
        return 'TEXTO LARGO';
      case ETipoCuestionario.TELEFONO:
        return 'TELÉFONO';
      
    }
  }
}
